import React, { useCallback, useState } from "react";
import { GridCellModesModel, GridCellParams, GridRowEditStopReasons, GridRowId } from "@mui/x-data-grid-pro";
import { ExplorerItemId } from "@/types/types.ts";
import useUserIsWriting from "@/common/hooks/useUserIsWriting.ts";
import { GridCellModes } from "@mui/x-data-grid/models";
import { GridRowEditStopParams } from "@mui/x-data-grid/models/params";

export const useCellEditMode = (/*id: ExplorerItemId & GridRowId, field: string*/) => {
  const userIsWriting = useUserIsWriting();
  const [cellModesModel, setCellModesModel] = useState<GridCellModesModel>({});

  const handleCellClick = useCallback(
    (params: GridCellParams, event: React.MouseEvent) => {
      // If Alt key is pressed, enter edit mode for the clicked cell
      if (event.altKey) {
        event.stopPropagation();
        const id = params.id as ExplorerItemId;

        setCellModesModel((prev) => {
          return {
            ...prev,
            [id]: { ...prev[id], [params.field]: { mode: GridCellModes.Edit } },
          } as GridCellModesModel
        });
      }
    },
    []
  );

  const handleCellEditStart = useCallback(
    (params: GridCellParams) => {
      if (!userIsWriting()) {
        return
      }
      const id = params.id as GridRowId;
      setCellModesModel((prev) => ({
        ...prev,
        [id]: { ...prev[id], [params.field]: { mode: GridCellModes.Edit } },
      } as GridCellModesModel));
    },
    [userIsWriting]
  );

  const handleCellEditStop = useCallback(
    (params: GridCellParams/*, event: MuiEvent*/) => {
      const { reason } = params as unknown as GridRowEditStopParams

      // For now, escape key to cancel cell updates is good.
      const ignoreModifications = reason === GridRowEditStopReasons.escapeKeyDown

      setCellModesModel(
        (prev) => ({
          ...prev,
          [params.id]: {
            ...prev[params.id],
            [params.field as string]: {
              mode: GridCellModes.View,
              ignoreModifications,
            },
          },
        } as GridCellModesModel)
      );
    },
    []
  );

  return {
    cellModesModel,
    setCellModesModel,
    handleCellClick,
    handleCellEditStart,
    handleCellEditStop,
  }
}